import _ from 'lodash';
import mergeArray from './mergeArray.js';
import isObject from './isObject.js';
import removeDirective, { removeKeyDirectives } from './removeDirectives.js';

const mergeObject = (a, b) => {
  if (_.isUndefined(b)) return a;
  if (_.isArray(b)) return mergeArray(a, b);
  if (!isObject(b)) return removeDirective(b);
  if (!isObject(a) || b.$replace) return removeDirective(b);

  const obj = _.omitBy(a, (v, k) => b[k] === '$remove');

  _.forIn(removeKeyDirectives(b), (v, k) => {
    obj[k] = mergeObject(a[k], v);
  });

  return obj;
};

export default mergeObject;
